export default __webpack_public_path__ + "static/media/h5-bg7.b2db60cb.png";